import React from "react";
import { Grid, makeStyles, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import EmployeeGroup from "../../types/EmployeeGroup";
import Employee from "../../types/Employee";
import { Training } from "../../types/Training";

interface IProps {
  users: Employee[];
  data: EmployeeGroup[];
  training?: Training[];
  onRemove: (group: EmployeeGroup) => void;
  onRemoveUser: (employee: Employee) => void;
  onRemoveTraining?: (training: Training) => void;
}
export default function TrainingSelectionViewer(props: IProps) {
  const {
    users,
    data,
    training,
    onRemove,
    onRemoveUser,
    onRemoveTraining,
  } = props;
  const classes = useStyles();
  return (
    <>
      <div className={classes.container}>
        <div className={classes.selected}>
          {(training?.length ?? 0) + data.length + users.length} entities
          selected:
        </div>
        <Grid container spacing={2}>
          {data.length > 0 &&
            data.map((t) => (
              <Grid item xs={12} key={t.employeeGroupId}>
                <div className={classes.listItem}>
                  <IconButton
                    className="close-button"
                    onClick={() => onRemove(t)}
                  >
                    <CloseIcon />
                  </IconButton>
                  <div className={classes.listText}>
                    {t.groupName} ({t.groupType})
                  </div>
                </div>
              </Grid>
            ))}
          {users.length > 0 &&
            users.map((t) => (
              <Grid item xs={12} key={t.employeeId}>
                <div className={classes.listItem}>
                  <IconButton
                    className="close-button"
                    onClick={() => onRemoveUser(t)}
                  >
                    <CloseIcon />
                  </IconButton>
                  <div className={classes.listText}>
                    {t.firstName} {t.lastName}
                  </div>
                </div>
              </Grid>
            ))}
          {training &&
            training.length > 0 &&
            training.map((t) => (
              <Grid item xs={12} key={t.trainingId}>
                <div className={classes.listItem}>
                  <IconButton
                    className="close-button"
                    onClick={() => onRemoveTraining?.(t)}
                  >
                    <CloseIcon />
                  </IconButton>
                  <div className={classes.listText}>{t.trainingTitle}</div>
                </div>
              </Grid>
            ))}
        </Grid>
      </div>
    </>
  );
}

const useStyles = makeStyles({
  container: {
    margin: 30,
  },
  selected: {
    fontSize: 14,
    margin: "30px 0 18px 0",
    textTransform: "uppercase",
  },
  listItem: {
    display: "flex",
    alignItems: "center",
  },
  listText: {
    marginLeft: 12,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  closeButton: {},
});
